export default {
  documents: [],
}